import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { Sort } from '@angular/material/sort';

import { DataService } from '../../data.service';

@Component({
  selector: 'app-metabuttonlist',
  templateUrl: './metabuttonlist.component.html',
  styleUrls: ['./metabuttonlist.component.scss']
})
export class MetabuttonListComponent implements OnInit {
  @Input() metaobjectid : string;
  @Input() objectname : string;
  @Input() parentobjectid : string;
  @Input() parentobjectname : string;
  @Input() embeddedobject : boolean;
  
  matSort: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaobjectId = "";
  objectName = "";
  metabuttonList=[];
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;
  
  displayedColumns: string[] = ['id', 'labelname', 'name', 'description', 'buttontype', 'actiontype',"modifiedby","modifieddate", 'active'];
  dataSource = new MatTableDataSource();

  sorting = {
    fieldName: 'labelname',
    order: 'ASC'
  }

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === '') {
      //default sorting
      this.sorting.fieldName = "createddate";
      this.sorting.order = "ASC";
    }
    else
    {
      const isAsc = sort.direction.toLocaleUpperCase() === 'ASC';
      this.sorting.fieldName = sort.active;
      if (isAsc) {
        this.sorting.order = "ASC";
      }
      else {
        this.sorting.order = "DESC";
      }
    }
    
    this.getMetabuttons().then(res => {
      console.log("response11111",res);

    }); 
  }

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder,
    private dataService: DataService) { }

  ngOnInit() {

    this.metaobjectId = this.metaobjectid;
    this.objectName = this.objectname;
    this.parentobjectId = this.parentobjectid;
    this.parentobjectName = this.parentobjectname;
    this.embeddedObject = this.embeddedobject;

    console.log("this.embeddedobject",this.embeddedobject);

    //load fields
    this.getMetabuttons().then(res => {
      console.log("response11111",res);

    }); 
    
  }

  newButton()
  {
    this.router.navigateByUrl('/home/metabutton/new/'+ this.metaobjectId + '/' + this.objectName + '/' + (this.parentobjectId==''?'none': this.parentobjectId) + '/' + (this.parentobjectName==''?'none': this.parentobjectName)  + '/' + this.embeddedObject );  
  }

  metaobjectList()
  {
        this.router.navigateByUrl('home/metaobjectlist');  
  }

  getMetabuttons(){
    return new Promise((resolve, reject) => {

      console.log("getMetabuttons");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid:localStorage.getItem("crm_userid"),
        username:localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          sortfield: this.sorting.fieldName,
          sortorder: this.sorting.order,  
          metabutton: {
            metaobjectid: this.metaobjectId
          }
        }
      }
      console.log("postOption", postOption)
      this.isLoading = true;
      this.dataService.getMetaButtons(postOption).subscribe(      
        res => {
          console.log(res);
          if(res !== null && res.success == 1){
            this.metabuttonList = res.data.metabuttons;

            //assign table data will refresh it automatically
            this.dataSource.data = this.metabuttonList;

            this.isLoading = false;
            resolve(null);
          }
          else{
            console.log("No metabuttons data!");
            this.errorMessage = (res!= null ? res.message : "No metabuttons data!");
            this.isError = true;  
            this.isLoading = false;
            resolve(null);
          }
        },
        err =>{
          console.log("Error***:",err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
  
      );
      
    });
  }

}
